import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Button, ButtonProps } from '../button';

export interface LinkButtonProps extends Omit<ButtonProps, 'ref' | 'children'> {
  className?: string;
  to: LinkProps['to'];
  replace?: LinkProps['replace'];
  target?: LinkProps['target'];
  linkClassName?: LinkProps['className'];
  LinkProps?: Omit<LinkProps, 'to' | 'children' | 'replace' | 'target' | 'className'>;
}

export const LinkButton = ((props: PropsWithChildren<LinkButtonProps>) => {
  const {
    children,
    className,
    to,
    replace,
    target,
    linkClassName,
    LinkProps,
    ...ButtonProps
  } = props;

  return (
    <Link className={classNames(linkClassName)} to={to} {...LinkProps} replace={replace} target={target}>
      <Button className={classNames(className)} {...ButtonProps}>
        {children}
      </Button>
    </Link>
  );
});

export default LinkButton;
